class ProductRecommendations extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  constructor () {
    super()

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }
        })
        .catch(e => {
          console.error(e)
        })
    }
    /* eslint-disable-next-line compat/compat */
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this)
  }

  fetchProducts () {
    /* eslint-disable-next-line no-console */
    console.log(
      `${this.baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}`,
    )
    try {
      return fetch(
        `${this.baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}`,
      )
        .then(res => res.text())
        .then(html => {
          const el = document.createElement('div')
          el.innerHTML = html
          /* eslint-disable-next-line no-console */
          console.log(el)
          this.innerHTML = el.firstElementChild.innerHTML
        })
    } catch (e) {
      console.error(e)
    }
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get productId () {
    return this.dataset.productId
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

customElements.define('product-recommendations', ProductRecommendations)
